import { useState } from "react"

import { EPlatform } from "@letshang/constants"

import { joinEvent } from "@api/firebaseWrappedApis"
import { updateUserDetails } from "@api/firebaseWrappedApis"

export const useSignup = () => {
  const [state, setState] = useState({
    isLoading: false,
    isSuccess: false,
  })

  const updateUser = async (userObj: any) => {
    if (userObj) {
      setState((prev) => ({ ...prev, isLoading: true }))

      try {
        userObj.platform = EPlatform.WEB
        const res: any = await updateUserDetails(userObj)

        if (res.success && userObj.eventId) {
          await joinEvent({ eventId: userObj.eventId })
        }

        return res
      } catch (e) {
        console.error(e)
      } finally {
        setState((prev) => ({ ...prev, isLoading: false }))
      }
    }
  }

  return {
    isLoading: state.isLoading,
    isSuccess: state.isSuccess,
    updateUser: updateUser,
  }
}
